import { useAppDispatch, useAppSelector } from "../../store";
import {
  cameraPermissionAllowed, currentMic, currentSpeaker, currentWebcam, endMeeting,
  isMicOn,
  isWebcamOn,
  meetingStatus,
  microphonePermissionAllowed,
  setCameraPermissionAllowed,
  setCurrentMicrophone,
  setCurrentSpeaker,
  setCurrentWebCamera,
  setIsMicOn,
  setIsWebcamOn,
  setMicrophonePermissionAllowed
} from "../../store/slices/video";
import { DeviceType } from "../../types/video";

const useVideoStore = () => {
  const dispatch = useAppDispatch();
  const micOn = useAppSelector(isMicOn);
  const webcamOn = useAppSelector(isWebcamOn);
  const isMeetingStarted = useAppSelector(meetingStatus);
  const selectedMic = useAppSelector(currentMic);
  const selectedWebcam = useAppSelector(currentWebcam);
  const selectedSpeaker = useAppSelector(currentSpeaker);
  const isCameraPermissionAllowed = useAppSelector(cameraPermissionAllowed);
  const isMicrophonePermissionAllowed = useAppSelector(microphonePermissionAllowed);

  const setMicOn = (value: boolean) => dispatch(setIsMicOn(value));
  const setWebcamOn = (value: boolean) => dispatch(setIsWebcamOn(value));
  const setSelectedMic = (device: DeviceType) => dispatch(setCurrentMicrophone(device));
  const setSelectedWebcam = (device: DeviceType) => dispatch(setCurrentWebCamera(device));
  const setSelectedSpeaker = (device: DeviceType) => dispatch(setCurrentSpeaker(device));
  const setIsCameraPermissionAllowed = (
    value: boolean
  ) => dispatch(setCameraPermissionAllowed(value));
  const setIsMicrophonePermissionAllowed = (
    value: boolean
  ) => dispatch(setMicrophonePermissionAllowed(value));
  const handleEndMeeting = () => dispatch(endMeeting());

  return {
    micOn,
    webcamOn,
    isMeetingStarted,
    selectedMic,
    selectedWebcam,
    selectedSpeaker,
    isCameraPermissionAllowed,
    isMicrophonePermissionAllowed,
    setMicOn,
    setWebcamOn,
    setSelectedMic,
    setSelectedWebcam,
    setSelectedSpeaker,
    setIsCameraPermissionAllowed,
    setIsMicrophonePermissionAllowed,
    handleEndMeeting
  };
};

export default useVideoStore;
